import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { StudyDesign, StudyEntityType } from '@faro/study-designer-model';
import { studyDesignClient } from './StudyDesignClient';

export type StudyDesignPathParameters = { id?: string; studyId: string };

const factory = createStudyEntityHookFactory<StudyDesign, StudyDesignPathParameters>(StudyEntityType.StudyDesign);

export const useStudyDesigns = factory.list(studyDesignClient.list);

export const useStudyDesign = factory.get(studyDesignClient.get);

export const useStudyDesignUpdate = factory.mutate(studyDesignClient.update);

export const useStudyDesignState = factory.getState();
